import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import Radium, { StyleRoot } from 'radium';
import {CSSProperties} from 'react';
import {browserHistory} from 'react-router';
import {connect} from 'react-redux';
import {BulletLine} from '../Components/BulletLine';
import {RealCampusAccountInfo} from './RealCampusAccountInfo';
import {RealCampusPasswordCard} from './RealCampusPasswordCard';
import {RealCampusActiveOrders} from './RealCampusActiveOrders';
import {RealCampusOrderHistory} from './RealCampusOrderHistory';
import {CSRCard} from '../Dashboard/CSRCard';
import {RealCampusHdr} from './RealCampusHdr';
import {RealCampusFooter} from './RealCampusFooter';
import {RealCampusFeedback} from './RealCampusFeedback';



class DashProps extends Tgcc.BaseProps{
    user: Tgcc.UserInfo;
}

const wrapperStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    height: 'auto',
}
const cardContainerStyle: CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'center',
    minWidth:'1000px',
    marginLeft:'20px'
}

const dashHdrLineR: CSSProperties = {
    width:'180px',
    backgroundColor:'#E9E6E6',
    height:'2px',
    display:'inline-block',
    marginBottom:'8px',
    marginRight:'10px'
}

const hrzLine:  CSSProperties = {
    width:'984px',
    height:'2px',
    backgroundColor:'#EEEDED',
    margin:'104px auto 20px auto'
}
const hdrDiv: CSSProperties = {
    textAlign:'center',
}
const dashHdr: CSSProperties = {
    display: 'flex',
    flexDirection:'column',
    border:'1px solid #5E6A74',
    height:'100%',
    position:'relative',
    left:'20px',
    top:'50px'
}
const link: CSSProperties = {
    color:'#5E6A74',
    width:'250px',
    height:'40px',
    fontFamily:'BarlowMedium',
    cursor:'pointer',
    textAlign:'center',
    padding:'0px 25px',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
}
let submitBtnStyle : CSSProperties = {
    backgroundColor:'#5E6A74',
    color:'white',
    width:'250px',
    height:'40px',
    margin:'0px auto 10px',
    textAlign:'center',
    lineHeight:'2.5em',
    fontFamily:'BarlowMedium',
    cursor:'pointer',
    border:'1px solid transparent',
    textTransform:'uppercase',
    ':hover': {
        backgroundColor:'white',
        color:'#5E6A74',
        border:'1px solid grey'
    }
}
const submitBtnStyle1 = Object.assign({},submitBtnStyle,{display:'none'})
const realDiv: CSSProperties = {
    display:'flex'
}

class _RealCampusDashboard extends React.Component<DashProps, any>{

    state = {
        compSelected:"Active Orders",
    }
    openStarted = () => {browserHistory.push(Tgcc.Routes.RealCampusProofEdit)};
    componentWillMount(){
        if(!this.props.state.LoginData)
            browserHistory.replace(Tgcc.Routes.RealCampusHome);
    }
    componentDidMount(){
        var tag = document.getElementById('campusDashboard');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }
    openActive = () => {
        this.setState({compSelected:"Active Orders"})   
    }
    openHistory = () => {
        this.setState({compSelected:"Order History"})        
    }
    openAccountInfo = () => {
        this.setState({compSelected:"Account Info"})        
    }
    openPassword = () => {
        this.setState({compSelected:"Change Password"})
    }
    getComp() {
        switch (this.state.compSelected) {
            case 'Active Orders':
                return <RealCampusActiveOrders state={this.props.state} />
            case 'Order History':
                return <RealCampusOrderHistory state={this.props.state} />
            case 'Account Info':
                return <RealCampusAccountInfo state={this.props.state} />
            case 'Change Password':
                return <RealCampusPasswordCard />
        }
    }
    
    getText(sel:string){
        if(this.state.compSelected === sel ){
            return Object.assign({},link,{textDecoration:'underline'})
        }
        else {
            return link
        }
    }       
    render() {
        var csrCard = Tgcc.UserIsAdmin(this.props.state) ? <CSRCard /> : null;
        return (
            <div style={wrapperStyle}>
            <div id='campusDashboard'></div>
            <RealCampusHdr />
            <RealCampusFeedback state={this.props.state} />
            <div style={realDiv} className="realDashDiv">
            <div style={submitBtnStyle1} onClick={this.openStarted} className="startOrderMobile">Start Your Order</div>
                <div style={dashHdr} className="realDashLinkDiv">
                    <div key={5} style={submitBtnStyle} className="startOrderReal" onClick={this.openStarted}>Start Your Order</div>
                    <div key={1} onClick={this.openActive} style={this.getText("Active Orders")} className="realDashLinks">Active Orders</div>
                    <div key={2} onClick={this.openHistory} style={this.getText("Order History")} className="realDashLinks">Order History</div>
                    <div key={3} onClick={this.openAccountInfo} style={this.getText("Account Info")} className="realDashLinks">Update Account</div>
                    <div key={4} onClick={this.openPassword} style={this.getText("Change Password")} className="realDashLinks">Change Password</div>
                </div>
            <div style={cardContainerStyle} className="compDiv">       
            {this.getComp()}
            </div>
            </div>
                {csrCard}
             
                <div style={hrzLine}>
                </div>
                <RealCampusFooter state={this.props.state} />
                <RealCampusFeedback state={this.props.state} />
            </div>
        );
    }
} 

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { state: state, user: state.UserInfo};
};
export var RealCampusDashboard = connect(mapStateToProps)(Radium(_RealCampusDashboard));

